module.exports = __webpack_public_path__ + "img/tools_bg1.9ccf89ad.jpg";